import validate from "/opt/build/repo/node_modules/nuxt/dist/pages/runtime/validate.js";
import route_45parsing_45global from "/opt/build/repo/middleware/routeParsing.global.js";
import manifest_45route_45rule from "/opt/build/repo/node_modules/nuxt/dist/app/middleware/manifest-route-rule.js";
export const globalMiddleware = [
  validate,
  route_45parsing_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {}